import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import "./EditCron.scss";
import { CNC_UPDATE_ACTION } from "../ActionsAPI";
import { showToast } from "../../../Forms/Dialogs/Toast/Toast";
import {
  mutationOptionsType,
  updateActionMutationResponseType,
} from "../ActionsTypes";
import {
  Tooltip,
  IconButton,
  TextInput,
  useMutationWrapper,
  showErrorDialog,
} from "@SeemplicityDev/shared";
/* eslint-disable no-unused-vars */

const enum CronMode {
  Read,
  Edit,
  Submitting,
}

const EditCron: React.FC<{
  accountUuid: string;
  actionId: string;
  displayName: string;
  cron: string;
}> = ({ accountUuid, actionId, displayName, cron }) => {
  const [mode, setMode] = useState<CronMode>(CronMode.Read);
  const [updateAction] = useMutationWrapper(CNC_UPDATE_ACTION, {
    refetchQueries: ["cncActions"],
  }) as unknown as [
    (
      variables: mutationOptionsType
    ) => Promise<updateActionMutationResponseType>,
  ];

  const updateCron = (formData: any) => {
    setMode(CronMode.Submitting);
    updateAction({
      variables: {
        account_uuid: accountUuid,
        action_id: actionId,
        cron: formData.cron,
      },
    })
      .then((res) => {
        setMode(CronMode.Read);
        showToast({
          message:
            `${displayName}\n cron has been changed to ${res?.data?.cnc_update_action?.action?.cron} successfully!` as any,
        });
      })
      .catch((err) => {
        setMode(CronMode.Edit);
        showErrorDialog({ message: err.message });
      });
  };

  const methods = useForm({ mode: "all" });
  const { handleSubmit, control } = methods;

  return mode === CronMode.Read ? (
    <div className={"cron-read"}>
      <Tooltip content={cron}>
        <span className="cron-text">{cron}</span>
      </Tooltip>
      {!!cron && (
        <IconButton
          data-testid={`edit-action-cron-${accountUuid}`}
          isIcon="seem-icon-edit"
          isRound
          type="button"
          onClick={() => {
            setMode(CronMode.Edit);
          }}
        />
      )}
    </div>
  ) : (
    <form onSubmit={handleSubmit(updateCron)}>
      <div className="edit-cron">
        <Controller
          name="cron"
          render={({ field: { onChange, value } }) => (
            <TextInput
              name="cron"
              wrapperClassName="cron-text"
              value={value}
              onChange={onChange}
              data-testid={`cron-edit-name-${accountUuid}`}
            />
          )}
          control={control}
          defaultValue={cron}
        />
        {mode === CronMode.Submitting ? (
          <div className="form-icon-button-wrap form-icon-button">
            <i className="seem-icon-spinner spinner" />
          </div>
        ) : (
          <IconButton
            data-testid={`edit-action-cron-${accountUuid}`}
            isIcon="seem-icon-save"
            isRound
            type="submit"
          />
        )}
      </div>
    </form>
  );
};
export default EditCron;
